import { NgModule } from '@angular/core';
import { IsFeatureActiveDirective } from './directives/is-feature-active/is-feature-active.directive';


@NgModule({
    declarations: [
        IsFeatureActiveDirective
    ],
    exports: [
        IsFeatureActiveDirective
    ]
})
export class FeatureToggleModule {
}
